import { useDispatch } from "react-redux";
import Modal from "../../utils/customModal";
import React, { useState, useEffect } from "react";
// import NotificationTypes from "./notificationTypes";
import { instanceAction } from "../../../Redux/api";
import { useTranslation } from "react-i18next";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
// import ClientCountries from "../../shared/countries/ClientCountries";
// import CustomSelect from "../custom-components/select";
import CustomSelect from "../../shared/custom-components/select";
import NotificationsIco from "../../../../static/images/notifications-black.svg";
import {
  loadingHtml,
  sucessInfoModal,
  errorContainer,
  moduleAction,
  cleanIputText,
} from "../../utils/functions";
import { MOD_PARAM, WRITE } from "../../../permissions";

const NotificationForm = (props) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [group, setGroup] = useState(props.group);
  const [readOnly, setReadOnly] = useState(props.readOnly);

  const [modal, setModal] = useState({
    show: false,
    content: null,
    onClose: undefined,
  });
  // const [statusInput, setStatusInput] = useState(props.group.isDeleted)

  useEffect(() => {
    if (readOnly !== props.readOnly) setReadOnly(props.readOnly);
    if (group !== props.group) setGroup(props.group);
  }, [props.group, props.readOnly]);

  const handlerChange = (e) => {
    let newGroup = { ...group };
    newGroup[e.target.name] = cleanIputText(e.target.type, e.target.value);
    setGroup(newGroup);
  };

  // eslint-disable-next-line no-unused-vars
  const countryHandler = (e) => {
    // setStatusInput(true)
    // let newGroup = { ...group };
    // newGroup.isDeleted = e;
    // setGroup(newGroup);
  };

  // const notificationHandler = (e) => {
  //   let newGroup = { ...group };

  //   if (e.target.checked == true) {
  //     newGroup.actions[e.target.name] = true;
  //   } else if (newGroup.actions[e.target.name] !== undefined) {
  //     delete newGroup.actions[e.target.name];
  //   }

  //   setGroup(newGroup);
  // };

  const closeModal = () => {
    setModal({ show: false, content: null, onClose: undefined });
  };

  const back = () => {
    props.history.push(`/bscadministrator/notifications`);
  };

  const save = () => {
    var url = `/type-notification-emails`;
    const method = props.groupid !== undefined ? "put" : "post";
    url = props.groupid !== undefined ? `${url}/${props.groupid}` : url;

    var data = { ...group };
    const buttons = {
      SelBtn: { text: t("general.buttons.continue"), action: back },
    };

    // Object.keys(group.actions).map((key) => data.actions.push(key));
    setModal({ show: true, content: loadingHtml(), onClose: undefined });

    return dispatch(instanceAction(url, method, data))
      .then(() => {
        setModal({
          show: true,
          content: sucessInfoModal(
            t("general.modal.notifications.title"),
            t("general.modal.notifications.subtitle"),
            buttons
          ),
          onClose: back,
        });
      })
      .catch((err) => {
        var error = err.response.data.notifications[0];
        var buttons = {
          continueBtn: { text: "Continuar", action: closeModal },
        };
        setModal({
          show: true,
          content: errorContainer(
            t("general.modal.global_approval.error_message"),
            error.description,
            buttons
          ),
          onClose: closeModal,
        });
      });
  };

  return (
    <React.Fragment>
      {props.approval !== true && (
        <div className="header-title flex-element">
          <div className="title gest-client flex-element">
            <img src={NotificationsIco} />
            <div className="client-gest">{t("notification.form.header")}</div>
          </div>
          {props.edit &&
            props.roles !== undefined &&
            moduleAction(props.roles, MOD_PARAM, WRITE) && (
              <p
                className={`left-flex edit-lbl ${!readOnly ? "disable" : ""}`}
                onClick={() => setReadOnly(!readOnly)}
              >
                {t("notification.form.edit")}
              </p>
            )}
        </div>
      )}
      <div id="add-client-user">
        <div
          className={`full-column clearfix ${!readOnly ? "editEnable" : ""}`}
        >
          <div className="row">
            <div className="input col-4">
              <label htmlFor="nameTypeNotificationEmailEs">
                {t("notification.form.notification_title_es")}
              </label>
              <input
                type="text"
                id="nameTypeNotificationEmailEs"
                name="nameTypeNotificationEmailEs"
                value={group.nameTypeNotificationEmailEs}
                onChange={(event) => handlerChange(event)}
                readOnly={readOnly}
              />
            </div>
            <div className="input col-4">
              <label htmlFor="nameTypeNotificationEmailEn">
                {t("notification.form.notification_title_en")}
              </label>
              <input
                type="text"
                id="nameTypeNotificationEmailEn"
                name="nameTypeNotificationEmailEn"
                value={group.nameTypeNotificationEmailEn}
                onChange={(event) => handlerChange(event)}
                readOnly={readOnly}
              />
            </div>
          </div>
          <div className="row">
            <div className="input col-4">
              <label htmlFor="descriptionTypeNotificationEmailEs">
                {t("notification.form.notification_description_es")}
              </label>
              <input
                type="text"
                id="descriptionTypeNotificationEmailEs"
                name="descriptionTypeNotificationEmailEs"
                value={group.descriptionTypeNotificationEmailEs}
                onChange={(event) => handlerChange(event)}
                readOnly={readOnly}
              />
            </div>
            <div className="input col-4">
              <label htmlFor="descriptionTypeNotificationEmailEn">
                {t("notification.form.notification_description_en")}
              </label>
              <input
                type="text"
                id="descriptionTypeNotificationEmailEn"
                name="descriptionTypeNotificationEmailEn"
                value={group.descriptionTypeNotificationEmailEn}
                onChange={(event) => handlerChange(event)}
                readOnly={readOnly}
              />
            </div>
          </div>
          <div className="row">
            {group.isDeleted ? (
              <div className="input col-4">
                <label htmlFor="name">Estatus</label>
                <CustomSelect
                  id={`client-country`}
                  className="client-country plain-form"
                  readOnly={readOnly}
                  value={group.isDeleted}
                  items={[
                    {
                      value: false,
                      name: `${t("general.states.ACTIVE")}`,
                    },
                    // {
                    //   value: "INACTIVE",
                    //   name: `${t("general.states.INACTIVE")}`,
                    // },
                    // {
                    //   value: "DELETED",
                    //   name: `${t("general.states.DELETED")}`,
                    // },
                  ]}
                  handleChange={(e) => countryHandler(e.value)}
                />
                {/* <CustomSelect
                className={`input input--text input-w-aux__input input--active as new-input-client`}
                items={[
                  {
                    value: "ACTIVE",
                    name: `${t("general.states.ACTIVE")}`,
                  },
                  {
                    value: "INACTIVE",
                    name: `${t("general.states.INACTIVE")}`,
                  },
                  {
                    value: "DELETED",
                    name: `${t("general.states.DELETED")}`,
                  },
                ]}
                name="companyState"

                valueAttr={"value"}
                id={`client-country`}
                onChange={(e) => countryHandler(e)}
                readOnly={readOnly}
                value={group.status}
              // handleChange={(event) =>
              //   setCompanyState(event.target.value)
              // }
              /> */}
              </div>
            ) : null}
          </div>
          {/* <div className="row">
            <div className="input col-4">
              <label htmlFor="name">{t("notification.form.name")}</label>
              <input
                type="text"
                id="name"
                name="name"
                value={group.name}
                onChange={(event) => handlerChange(event)}
                readOnly={readOnly}
              />
            </div>
            <div className="input col-4">
              <label htmlFor="name">{t("notification.form.country")}</label>
              <ClientCountries
                id={`client-country`}
                className="client-country plain-form"
                onChange={(e) => countryHandler(e)}
                readOnly={readOnly}
                value={group.countryCode}
              />
            </div>
            <div className="input col-4">
              <label htmlFor="email">{t("notification.form.email")}</label>
              <input
                type="text"
                id="email"
                name="email"
                value={group.email}
                onChange={(event) => handlerChange(event)}
                readOnly={readOnly}
              />
            </div>
          </div> */}
          {/* <h2 className="label-admin-client">{t("notification.form.notification")}</h2>
          <div className="full-size">
            <NotificationTypes
              readOnly={readOnly}
              notifications={group.actions}
              changeHandler={notificationHandler}
            />
          </div> */}
        </div>
        {props.approval !== true && (
          <div className="form-actions clearfix">
            <SecondaryButton id="go-back" onClick={back}>
              {t("general.buttons.back")}
            </SecondaryButton>
            {props.roles !== undefined &&
              moduleAction(props.roles, MOD_PARAM, WRITE) && (
                <SecondaryButton id="sendForApproval" onClick={save}>
                  {t("notification.form.send")}
                </SecondaryButton>
              )}
          </div>
        )}
      </div>
      <Modal show={modal.show} handleClose={modal.onClose}>
        {modal.content}
      </Modal>
    </React.Fragment>
  );
};

export default NotificationForm;
